import art from "assets/images/arts/grey1.jpg";
const About = () => {
  return (
    <section id="about">
      <div className="container">
        <div className="row about-row">
          <div className="about-left">
            <div className="description" data-aos="fade-up">
              <h2>WELCOME TO THE <div className="colored">Business Ape Club !</div></h2>
              <p>
                The Business Ape Club brings together people of entrepreneurial spirit and philanthropic nature who believe that their own hard work and risk in business and investment deserve a fair reward for themselves and a helping hand for anyone less fortunate.
              </p>
              <p>
                Your starting point will be to adopt a Business Ape to head your enterprise and join the club! The holding of our Business Apes will grant you various benefits along the road of the project’s development. The prestige of your Business Ape will reflect your entrepreneurial spirit and subsequent exclusive status.
              </p>
            </div>
          </div>
          <div className="about-right">
            <img data-aos="fade-down" className="about-img" src={art} alt="Business Ape Club" />
          </div>
        </div>
        <div className="about-club">
          <div className="story-head">
            <h4 data-aos="fade-up">
              The Club
            </h4>
          </div>
            <p data-aos="fade-down">
              Membership grants you access to our exclusive business community and network of prosperity. As our project develops, we will implement a token minting system for holding a Business Ape to ensure your investment’s success. The Business Ape will produce Jungle Bonds ($JBND) as rewards to holders which will then be exchangeable to mint a new Private Secretary Ape NFT. Holders of both NFTs will be granted further benefits yet to be announced. We will also be looking to make an organised investment incursion into the metaverse for all our members.
            </p>
        </div>
      </div>

    </section>
  );
};

export default About;
